var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDAhuGeneralHeatRecoveryDP = function SvgDAhuGeneralHeatRecoveryDP(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684 480",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "301,201 299,201 299,177 263,177 263,201 261,201 261,175 301,175"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 176,
    r: 11,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,166c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S275.5,166,281,166 M281,165c-6.1,0-11,4.9-11,11s4.9,11,11,11 s11-4.9,11-11S287.1,165,281,165L281,165z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M278.5,172.6h1l2.2,5.7h-5.5L278.5,172.6z M277.5,177.6h2.9l-1.4-3.7L277.5,177.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.8,176.3c0,0.6-0.1,1.2-0.5,1.6s-0.7,0.6-1.2,0.6c-0.5,0-0.8-0.1-1.1-0.5v2h-1v-5.9h0.9l0,0.4 c0.3-0.3,0.7-0.5,1.1-0.5c0.5,0,0.9,0.2,1.2,0.6C285.6,175,285.8,175.5,285.8,176.3L285.8,176.3L285.8,176.3z M284.9,176.2 c0-0.4-0.1-0.8-0.2-1c-0.2-0.2-0.4-0.4-0.7-0.4c-0.4,0-0.7,0.2-0.8,0.5v1.9c0.2,0.3,0.5,0.5,0.8,0.5c0.3,0,0.5-0.1,0.7-0.4 C284.8,177.1,284.9,176.7,284.9,176.2z"
  })))))));
};
export default SvgDAhuGeneralHeatRecoveryDP;